(() => {
  const SELECTOR = '[data-rp-product-faq]';

  if (window.RemediuProductFaqManager) {
    window.RemediuProductFaqManager.mountWithin();
    return;
  }

  const instances = new WeakMap();

  class RemediuProductFaq {
    constructor(root) {
      this.root = root;
      this.items = [...root.querySelectorAll('[data-rp-faq-item]')];
      this.handlers = new Map();

      this.items.forEach((item) => {
        const handler = () => this.onToggle(item);
        this.handlers.set(item, handler);
        item.addEventListener('toggle', handler);
      });
    }

    onToggle(activeItem) {
      if (!activeItem.open) return;

      this.items.forEach((item) => {
        if (item !== activeItem) item.open = false;
      });
    }

    destroy() {
      this.handlers.forEach((handler, item) => {
        item.removeEventListener('toggle', handler);
      });
      this.handlers.clear();
    }
  }

  const mount = (root) => {
    if (!root || instances.has(root)) return;
    instances.set(root, new RemediuProductFaq(root));
  };

  const unmount = (root) => {
    const instance = instances.get(root);
    if (!instance) return;
    instance.destroy();
    instances.delete(root);
  };

  const mountWithin = (container = document) => {
    if (container.matches?.(SELECTOR)) mount(container);
    container.querySelectorAll?.(SELECTOR).forEach(mount);
  };

  window.RemediuProductFaq = RemediuProductFaq;
  window.RemediuProductFaqManager = { mountWithin, unmount };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => mountWithin());
  } else {
    mountWithin();
  }

  document.addEventListener('shopify:section:load', (event) => mountWithin(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.matches?.(SELECTOR)
      ? event.target
      : event.target.querySelector?.(SELECTOR);
    unmount(root);
  });
})();
